import { UseCase } from '../../base/UserCase';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CartRepository } from 'src/app/core/repositories/cart/CartRepository';
import {
    CartRequestDTO,
    CartResponse,
} from 'src/app/data/dto/CartDTO';

@Injectable({
    providedIn: 'root'
})

export class AddToCartUseCase implements UseCase<CartRequestDTO, CartResponse> {
    constructor(
        private cartRepository: CartRepository,
    ) { }

    execute(request: CartRequestDTO): Observable<CartResponse> {
        return this.cartRepository.createCart(request);
    }
}
